(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('SelectRiaPlanVariant', [
			'orderFormFactory',
			'urlFactory',
			SelectRiaPlanVariantFunction
		]);

	function SelectRiaPlanVariantFunction(
		orderFormFactory,
		urlFactory) {

		var selectPlan = this;

		selectPlan.handleSelection = function(riaPlanId) {
			orderFormFactory.submitOrderForm(riaPlanId, 'ADVANCED').then(function() {
				urlFactory.redirect('/reits/checkout/start');
			});
		};
	}
})(window.angular);